"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _defaultTheme = _interopRequireDefault(require("@kiwicom/orbit-components/lib/defaultTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PasswordStrengthBar = _ref => {
  let {
    color,
    width
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "w-[200px]",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "rounded-[12px] bg-elevation-suppressed",
      style: {
        boxShadow: `inset 0 1px 2px ${_defaultTheme.default.orbit.elevationSuppressedBackground}, 0 1px ${_defaultTheme.default.orbit.paletteCloudNormal}`
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-test": "MagicLogin-PasswordStrengthBar",
        className: "h-xxs rounded-badge transition-[width] duration-[0.5s] ease-in-out",
        style: {
          backgroundColor: color,
          width
        }
      })
    })
  });
};
var _default = exports.default = PasswordStrengthBar;